
(function() {
  var result = { translations: { "af": { "i18n": { "duration": { "seconds": "{{ seconds }} sekondes", "minutes": "{{ minutes }} minute", "hours": "{{ hours }} uur", "hoursAndMinutes": "{{ hours }} uur {{ minutes }} min", "days": "{{ days }} dae", "shortForm": { "seconds": "{{ seconds }}s", "minutes": "{{ minutes }}m", "hours": "{{ hours }}u", "days": "{{ days }}d", "hoursAndMinutes": "{{ hours }}u{{ minutes }}m" } }, "dateTime": { "quarterAndYear": "{{quarterNumber}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}, uitbr. {{extension}}" } } } } };
  result.translationsLoaded = {
  "I18n": {
    "af": "static-7.1342"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.1342",
    "ar-eg": "static-7.1342",
    "bg": "static-7.1342",
    "bn": "static-7.1342",
    "ca-es": "static-7.1342",
    "cs": "static-7.1342",
    "da": "static-7.1342",
    "de": "static-7.1342",
    "el": "static-7.1342",
    "en-gb": "static-7.1342",
    "en": "static-7.1342",
    "es-mx": "static-7.1342",
    "es": "static-7.1342",
    "et": "static-7.1342",
    "fi": "static-7.1342",
    "fr-ca": "static-7.1342",
    "fr": "static-7.1342",
    "he-il": "static-7.1342",
    "hi": "static-7.1342",
    "hr": "static-7.1342",
    "hu": "static-7.1342",
    "id": "static-7.1342",
    "it": "static-7.1342",
    "ja": "static-7.1342",
    "ko": "static-7.1342",
    "lt": "static-7.1342",
    "ms": "static-7.1342",
    "nl": "static-7.1342",
    "no": "static-7.1342",
    "pl": "static-7.1342",
    "pt-br": "static-7.1342",
    "pt-pt": "static-7.1342",
    "ro": "static-7.1342",
    "ru": "static-7.1342",
    "sk": "static-7.1342",
    "sl": "static-7.1342",
    "sv": "static-7.1342",
    "th": "static-7.1342",
    "tl": "static-7.1342",
    "tr": "static-7.1342",
    "uk": "static-7.1342",
    "vi": "static-7.1342",
    "x-pseudo": "static-7.1342",
    "zh-cn": "static-7.1342",
    "zh-hk": "static-7.1342",
    "zh-tw": "static-7.1342"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:af', {version: 'static-7.1342'}); }
})();


